import PropTypes from "prop-types";

export default PropTypes.shape({
  timeToHire: PropTypes.shape({
    yourAvgTimeToHire: PropTypes.string,
    hhAvgTimeToHire: PropTypes.string,
    industryAvgTimeToHire: PropTypes.string,
  }),
});
